import React from "react";
import BlogContainer from "./container/BlogContainer";
const Blog = () => {
    return (
        <BlogContainer />
    )
}
export default Blog
